module.exports = __webpack_public_path__ + "static/media/R1_ROUGH.dce0fc07.png";